import { render, staticRenderFns } from "./OrderById.vue?vue&type=template&id=485b685e&scoped=true"
import script from "./OrderById.vue?vue&type=script&lang=js"
export * from "./OrderById.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b685e",
  null
  
)

export default component.exports